import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Referrals from "./pages/Referrals";
import PreOrder from "./pages/PreOrder";
import "./App.css";

function App() {
  return (
    <Router>
      <header className="header">
        <img src="/images/logo.png" alt="Logo" className="logo" />
        <div class="cravyque-logo">CRAVYQUÉ</div>
        <nav className="navbar">
          {/* <Link to="/">Home</Link> */}
          {/* <Link to="/preorder">Order</Link> */}
          {/* <Link to="/contact">Contact</Link> */}
          {/* <Link to="/about">About</Link> */}
          {/* <Link to="/referrals">Referrals</Link> */}
        </nav>
      </header>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/preorder" element={<PreOrder />} /> */}
        {/* <Route path="/about" element={<About />} /> */}
        {/* <Route path="/contact" element={<Contact />} /> */}
        {/* <Route path="/referrals" element={<Referrals />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
